<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5967 13.6393L16 6L13.4033 13.6393L5 13.6393L11.7984 18.3607L9.20163 26L16 21.2786L22.7984 26L20.2016 18.3607L27 13.6393L18.5967 13.6393ZM23.5101 14.7232H17.7729L16 9.50756L14.2271 14.7232H8.48988L13.1314 17.9467L11.3585 23.1623L16 19.9389L20.6415 23.1623L18.8686 17.9467L23.5101 14.7232Z"
      fill="currentColor"/>
  </svg>
</template>
